<ng-container *ngIf="!!transactionResultReqParams">
    <app-payment
        [transactionResultReqParams]="transactionResultReqParams"
        [cardType]="cardType"
        [mdStatus]="mdStatus"
        [ErrMsg]="ErrMsg"
        [amount]="amount"
        [mdErrorMsg]="mdErrorMsg"
    ></app-payment>
</ng-container>